// extracted by mini-css-extract-plugin
export var attachment = "_i8-a";
export var emailContainer = "_i8-4";
export var emailContentPaddedContainer = "_i8-b";
export var emailHeader = "_i8-6";
export var emailIframe = "_i8-3";
export var emailInfoIcon = "_i8-9";
export var emailShortenedSummary = "_i8-e";
export var infoDropdown = "_i8-0";
export var infoRowBoundedContent = "_i8-d";
export var internal = "_i8-5";
export var merchant = "_i8-8";
export var messageInputContainer = "_i8-h";
export var normal = "_i8-7";
export var replyCard = "_i8-f";
export var subtleButton = "_i8-1";
export var subtleButtonIconContainer = "_i8-2";
export var toggleViewRepliesButton = "_i8-c";
export var wrappingText = "_i8-g";